import React, { FunctionComponent } from "react";
import { createStackNavigator } from "@react-navigation/stack";

import ViewProfileScreen from "../screens/ViewProfileScreen";
import { ScreenHeaderTitle } from "../components/ScreenHeader";
import { commonHeader } from "./AuthNavigator";
import EditProfileScreen from "../screens/EditProfileScreen";

const ProfileStack = createStackNavigator();

interface Props {
  route: any;
}

const ProfileNavigator: FunctionComponent<Props> = ({ route }) => (
  <ProfileStack.Navigator screenOptions={{ headerTitleAlign: "center" }}>
    <ProfileStack.Screen
      name="CustomerProfile"
      component={ViewProfileScreen}
      initialParams={{ customer: route.params.customer }}
      options={{
        ...commonHeader,
        title: "Profile",
        headerTitle: (props) => <ScreenHeaderTitle {...props} />,
      }}
    />
    <ProfileStack.Screen
      name="EditProfile"
      component={EditProfileScreen}
      initialParams={{ customer: route.params.customer }}
      options={{ headerShown: false }}
    />
  </ProfileStack.Navigator>
);

export default ProfileNavigator;
